var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._g({staticClass:"inline-flex items-center rounded-full py-0.5 font-medium",class:_vm.small ? 'px-2.5 text-xs' : 'px-3 text-sm'},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }